import type { ItemStat } from './types';
import { memberPill } from './insightStats';

/** Members shown when a group row is expanded. */
export const MAX_MEMBERS = 6;
const TRACE_MIN_EATEN = 4;

export function sortedMembers(group: ItemStat): ItemStat[] {
  return [...(group.memberStats ?? [])].sort((a, b) => b.timesEaten - a.timesEaten || a.name.localeCompare(b.name));
}

export interface TriggerSections {
  /** Groups whose verdict is Suspect: shown under "Main triggers". */
  suspectGroups: ItemStat[];
  /** Every other eaten group: shown under "Food groups". */
  otherGroups: ItemStat[];
  /** Ingredient leads shown standalone under "Main triggers". */
  leads: ItemStat[];
}

/**
 * Split groups and ingredient leads into the Insights sections. An ingredient lead is left out of the
 * standalone list only when it is already listed under a suspect group in "Main triggers"; a lead that
 * belongs to a "Likely fine" or "Unclear" group (e.g. milk under dairy) still shows as a main trigger.
 */
export function triggerSections(components: ItemStat[], ingredients: ItemStat[]): TriggerSections {
  const groups = components.filter(
    (g) => g.timesEaten > 0 && (g.name !== 'soy (trace)' || g.timesEaten >= TRACE_MIN_EATEN)
  );
  const suspectGroups = groups.filter((g) => memberPill(g) === 'Suspect');
  const otherGroups = groups.filter((g) => memberPill(g) !== 'Suspect');
  const inSuspectGroups = new Set(
    suspectGroups.flatMap((g) => sortedMembers(g).slice(0, MAX_MEMBERS).map((m) => m.name))
  );
  const leads = ingredients.filter((s) => !inSuspectGroups.has(s.name));
  return { suspectGroups, otherGroups, leads };
}
